module.exports = __webpack_public_path__ + "img/ULYAN.0492abd3.png";